import React, { useState } from "react";
import axios from "axios";

function UploadResume({ onClose }) {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [touched, setTouched] = useState(false);

  const isValidFileType = (filename) =>
    /\.(pdf|docx|png|jpg|jpeg|gif)$/i.test(filename);

  const handleFileChange = (event) => {
    setTouched(true);
    const selectedFile = event.target.files[0];
    if (selectedFile && isValidFileType(selectedFile.name)) {
      setFile(selectedFile);
      setError("");
    } else {
      setError(
        "Invalid file type. Please upload a PDF, DOCX, PNG, JPG, or GIF.",
      );
      setFile(null);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      setError("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", file.type);

    const token = localStorage.getItem("authToken");
    if (!token) {
      setError("No authentication token found. Please log in again.");
      return;
    }

    try {
      const response = await axios.post(
        "https://genz-staging.feeltiptop.com/api/media/upload_file",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setMessage("File uploaded successfully!");
      setError("");
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        error.response?.data?.error ||
          "Error uploading file. Please check format and try again.",
      );
    }
  };

  return (
    <div className="flex">
      <div className="relative w-[550px] rounded-2xl bg-white p-4 shadow-xl">
        <button
          onClick={onClose}
          className="absolute right-5 top-5 rounded-lg px-3 py-2 text-right font-semibold shadow-sm"
        >
          X
        </button>

        {/* Title & Subtitle (left-aligned) */}
        <div className="mb-6">
          <h2 className="text-left text-xl font-normal text-gray-900">
            Upload Resume
          </h2>
          <p className="text-normal mt-1 text-left text-gray-500">
            You can upload one file at a time, with a maximum size of XX MB.
          </p>
        </div>

        {/* Upload Area (centered) */}
        <form onSubmit={handleSubmit} className="m-0">
          <div className="flex justify-center">
            <label
              htmlFor="file-upload"
              className="flex w-full max-w-md cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 py-2 text-center"
            >
              <img
                src="/Featured icon.svg"
                alt="Upload Icon"
                className="mb-3 h-10 w-10"
              />
              <span className="text-sm">
                <span className="text-blue-600 hover:underline">
                  Click to upload
                </span>{" "}
                or drag and drop
              </span>
              <span className="mt-1 text-xs text-gray-400">
                PDF, PNG, JPG or GIF (max. XX x XX px)
              </span>
              <input
                id="file-upload"
                type="file"
                onChange={handleFileChange}
                className="hidden"
                accept=".pdf,.docx,.png,.jpg,.jpeg,.gif"
              />
            </label>
          </div>

          {touched && !file && (
            <p className="mt-2 text-center text-sm text-red-500">
              ❌ No valid file attached yet
            </p>
          )}
          {file && (
            <p className="mt-2 text-center text-sm text-green-700">
              ✅ File attached: <span className="font-medium">{file.name}</span>
            </p>
          )}

          {/* Upload Button (right-aligned) */}
          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              className="rounded-2xl bg-blue-500 px-4 py-1 font-semibold text-white transition hover:bg-blue-700"
            >
              Upload
            </button>
          </div>
        </form>

        {/* Messages */}
        {message && (
          <p className="mt-4 text-center text-sm text-green-600">{message}</p>
        )}
        {error && (
          <p className="mt-4 text-center text-sm text-red-500">{error}</p>
        )}
      </div>
    </div>
  );
}

export default UploadResume;
